import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export default function Lightbox({ isOpen, imageSrc, imageData, onClose, onPrev, onNext }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
        >
          {/* Dark Backdrop */}
          <motion.div
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* Modal Content */}
          <motion.div
            className="relative max-w-4xl max-h-[90vh] w-full mx-4 z-10 flex flex-col"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <motion.button
              onClick={onClose}
              className="absolute -top-12 right-0 text-white hover:text-Pink-main transition z-20"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Lukk lightbox"
            >
              <X size={32} strokeWidth={2} />
            </motion.button>

            {/* Image Container with Navigation */}
            <div className="flex flex-col items-center justify-center gap-4">
              {/* Image */}
              <motion.img
                src={imageSrc}
                alt={imageData?.title || "Forstørret bilde"}
                className="w-full h-auto rounded-lg max-h-[60vh] object-contain"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.4 }}
              />

              {/* Navigation Buttons */}
              <div className="flex items-center justify-center gap-8 md:gap-12">
                {/* Left Arrow */}
                <motion.button
                  onClick={onPrev}
                  className="text-white hover:opacity-70 transition z-20"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label="Forrige bilde"
                >
                  <ChevronLeft size={40} strokeWidth={2} />
                </motion.button>

                {/* Right Arrow */}
                <motion.button
                  onClick={onNext}
                  className="text-white hover:opacity-70 transition z-20"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label="Neste bilde"
                >
                  <ChevronRight size={40} strokeWidth={2} />
                </motion.button>
              </div>
            </div>

            {/* Image Title and Description */}
            {imageData && (
              <motion.div
                className="mt-4 text-white text-center"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.1 }}
              >
                {imageData.title && (
                  <h3 className="text-xl font-semibold mb-2">{imageData.title}</h3>
                )}
                {imageData.description && (
                  <p className="text-sm text-gray-300">{imageData.description}</p>
                )}
              </motion.div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
